const strutil = {
    isMobile(str) {
        return /(0|86|17951)?(13[0-9]|15[0-9]|17[678]|18[0-9]|14[57]|19[0-9]|16[0-9])[0-9]{8}$/
            .test(str);
    }
};

export default strutil;